<template>
    <div>
        <div @click='toggleMobileMenu'><i class="fa-regular fa-bars hamburger"></i></div>
        <div class="mobile-menu">
            <div class='mobile-menu-content'>
                <div class='close-mobile-menu-container'>
                    <Logo/>
                    <div @click='toggleMobileMenu'><div class="fa-regular fa-xmark close-mobile-menu"></div></div>
                </div>
                <div class='mobile-item-headings'>
                    <div v-for='heading in headings' class='heading-container' :key="heading.id">
                        <div @click='selectedMenuItem(heading.sef_url)'>
                            {{heading.name}}
                        </div>
                        <div class='icon-container' @click='openSubMenu(heading)'>
                            <i class="fa-solid fa-angle-right right-arrow"></i>
                        </div>
                    </div>
                    <MobileSubMenu :open_sub_menu='open_sub_menu_watcher' :selected_heading='selected_heading' @selectedMenuItemListener='selectedMenuItem'/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MobileSubMenu from '@/ecom/components/navigation/header/menus/MobileSubMenu.vue';
import Logo from '@/ecom/components/navigation/header/Logo.vue';

export default {
    components:{MobileSubMenu, Logo},
    props: ['menu_items', 'headings', 'sub_headings'],
    data(){
        return{
            open_sub_menu_watcher: null,
            selected_heading: []
        }
    },
    methods:{
        toggleMobileMenu(){
            const mobile_menu = document.querySelector('.mobile-menu');
            mobile_menu.classList.toggle('is-open');
        },
        selectedMenuItem(url){
            this.$router.push(`/${url}`);
            this.toggleMobileMenu();
        },
        openSubMenu(heading){
            this.selected_heading = this.menu_items.filter(x=>x.id == heading.id)[0];
            this.open_sub_menu_watcher = +new Date();
        }
    }
}
</script>
<style lang="scss" scoped>

.hamburger{
    display: none;
    font-size: 1.2rem;
    color: white;

    @media(max-width: 768px){
        display: block;
    }
}

.mobile-menu {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	// height: 100%;
    height: 100dvh;
	z-index: 100;
    background-color: #040711;
	color: white;
	transform: translateY(-100%);
	transition: 0.3s;
    transition: transform 330ms ease-in-out;
    // overflow-y: auto;
    // overflow-x: hidden;
    overflow: hidden;
}

.mobile-menu.is-open {
	transform: translateY(0);
    transition: 0.7s;
    transition: transform 330ms ease-in-out;
}

.mobile-menu-content{
    padding: 20px;
    height: 100%;
}

.close-mobile-menu-container{
    display: flex;
    justify-content: space-between
}
.close-mobile-menu{
    font-size: 2.5rem;
}

.mobile-item-headings{
    font-size: 1.1rem;
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-top: 30px;
    position: relative;
    // overflow-y: auto;
}

.heading-container{
    display: flex;
    align-items: center;
    // justify-content: space-between;
}

.right-arrow{
    color: var(--primary-colour-2);
    float: right;
}
.icon-container{
    flex-grow: 1;
}
</style>